import React, { useEffect, useState } from "react";

import {
  isAdmin,
  isVolunteer,
  replaceIdInUrl,
  toastMaker,
} from "../../utils/utility";
import {
  LIST_MY_PROFILES,
  UPDATE_PROFILE,
  VIEW_MY_PROFILE,
  PAYMENT_VIA_PROFILE,
  EDIT_PROFILE,
  UPDATE_PROFILE_VISIBILITY,
  GET_PROFILE_VISIBILITY,
} from "../../API_LIST";
import matrimonyInstance from "../../utils/axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Popup from "./popup";
import { useDispatch, useSelector } from "react-redux";
import StripeSubscription from "../payment/StripeSubscription";
import EditProfile from "../../pages/editProfile";
import {
  setPaymentUserDetails,
  setPaymentVisible,
} from "../../redux/features/paymentSlice";

const relations = [
  "Son",
  "Daughter",
  "Brother",
  "Sister",
  "Relative",
  "Friend",
  "Self",
];

const ProfileData = [
  { name: "First Name", key: "first_name" },
  { name: "Last Name", key: "last_name" },
  { name: "Birth Year", key: "birth_year" },
  { name: "Birth Month", key: "birth_month" },
  { name: "Gotram", key: "gothram" },
  { name: "Birth Star", key: "birth_star" },
  { name: "Lagna", key: "lagna" },
  { name: "Place of Birth", key: "place_of_birth" },
  { name: "Time of Birth", key: "time_of_birth" },
  { name: "Height", key: "height" },
  { name: "Weight", key: "weight" },
  { name: "Education & School", key: "education" },
  { name: "Resident Status", key: "resident_status" },
  { name: "Profession", key: "profession" },
  { name: "Current Employer", key: "current_employer" },
  { name: "Current Location", key: "current_location" },
  { name: "Siblings", key: "siblings" },
  { name: "Mandatory Requirements", key: "mandatory_requirements" },
  { name: "Other Details", key: "other_details" },
];

export default function ViewProfileAccordion({ profileData }) {
  const disPatch = useDispatch();
  const [userDetails, setUserDetails] = useState();

  const [modalIsOpen, setIsOpen] = useState(false);
  const isPaymentVisible = useSelector(
    (state) => state.payment.isPaymentVisible
  );

  useEffect(() => {
    setUserDetails(profileData);
  }, []);

  function closeModal() {
    setIsOpen(false);
  }

  // let profileStatusImage;
  // if (userDetails?.profile_verification_status === "approved") {
  //   profileStatusImage = "status-approved";
  // } else if (userDetails?.profile_verification_status === "declined") {
  //   profileStatusImage = "status-rejected";
  // } else {
  //   profileStatusImage = "status-pending";
  // }

  let paymentStatusImage;
  if (userDetails?.payment_status === "active") {
    paymentStatusImage = "payment-done";
  } else {
    paymentStatusImage = "payment-failed";
  }

  let canApprove = isAdmin() || isVolunteer();

  const updateVisibility = async (e) => {
    const updateKey = e.target.name;
    const updateValue = !userDetails[updateKey];

    const updateField = { [updateKey]: updateValue };

    setUserDetails({
      ...userDetails,
      ...updateField,
    });

    const data = { field: updateKey, value: updateValue };
    const id = userDetails?.profile_id;
    let url = replaceIdInUrl(UPDATE_PROFILE_VISIBILITY, id);
    matrimonyInstance
      .put(url, data)
      .then((response) => {
        toastMaker(response?.data?.message, "success");
      })
      .catch((error) => {
        console.log("error");
        toastMaker(error, "error");
      });
  };

  useEffect(() => {
    window?.scrollTo(0, 0);
  }, [isPaymentVisible]);

  return (
    <React.Fragment>
      {!isPaymentVisible ? (
        <React.Fragment>
          <div className="d-flex justify-content-center">
            {userDetails && (
              <div className="view-profile-card mb-5 mt-5 toggle-profile-data-grid-responive-card">
                <div className="toggle-profile-data-grid-responive">
                {ProfileData?.map((item, index) => {
                  const value = userDetails?.[item?.key];

                  return value !== undefined ? (
                    <p key={index} id="toggle-profile-data">
                      <span className="key mr-10">{item?.name}:</span>
                      {item?.key === "relation_id" ? (
                        <span>{relations[value - 1]}</span>
                      ) : (
                        <span className={value === "hidden" || value === "" ? "" : ""}>
                          {value === "hidden" || value === "" ? "N/A" : value}
                        </span>
                      )}
                    </p>
                  ) : null;
                })}
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          {userDetails &&
            userDetails?.profile_id &&
            !canApprove &&
            userDetails.payment_status === "unpaid" && (
              // userDetails.profile_verification_status === "approved" &&
              <div className="d-flex justify-content-center">
                <div className="view-profile-card mb-50 mt-50 pb-50">
                  <div className="d-flex justify-content-end">
                    <button
                      className="button payment-btn"
                      onClick={() => disPatch(setPaymentVisible(false))}>
                      Back to Profile
                    </button>
                  </div>
                  <div className="d-flex justify-content-center">
                    <div style={{ width: "max-content" }}>
                      <StripeSubscription
                        profileId={userDetails?.profile_id}
                        accountEmail={userDetails?.account_email}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
        </React.Fragment>
      )}
      <Popup
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
        html={
          <EditProfile
            isEdit={true}
            userDetails={userDetails}
            closeModal={closeModal}
            setUserDetails={setUserDetails}
          />
        }
      />
    </React.Fragment>
  );
}
